import * as React from 'react';
import styled from 'styled-components';

import Flex from '../flex';

export interface NavbarProps {
  className?: string;
  children?: any;
}

export const Navbar: React.FC<NavbarProps> = (props) => (
  <Flex className={props.className}>{props.children}</Flex>
);

export default styled(Navbar)`
  height: 100%;
  width: 100%;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 12px;

  @media ${({ theme }) => theme.device.tablet} {
    height: 100%;
    width: auto;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
  }

  .navbar-item {
    &:last-child {
      margin-bottom: 0;

      @media ${({ theme }) => theme.device.tablet} {
        margin-right: 0;
      }
    }
  }
`;
